import defaultAttributes from '../defaultAttributes';

const ArrowBigLeft = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M3 12l7-7v4h11v6H10v4z' }]],
];

export default ArrowBigLeft;
